import { defaultLang, allowedLanguages } from 'config/languageSelector';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
const queryString = require('query-string');

function LanguageSwitcher() {
  const location = useLocation();

  useEffect(() => {
    // console.log(location);
    const parsed = queryString.parse(location.search);
    let lang = parsed.lang;
    captureLanguage(lang);
  }, [location.pathname]);

  return null;
}

const captureLanguage = (queryLang) => {
  const prevLang = localStorage.getItem('lang');
  const isQueryLangValid = allowedLanguages.includes(queryLang);
  let newLang = '';

  if (isQueryLangValid) {
    newLang = queryLang;
  } else {
    newLang = defaultLang;
    if (prevLang) {
      newLang = prevLang;
    }
  }

  // Final check to see if there is a change in the language. Hard reload to reload the DOM and config file chosen!
  if (prevLang !== newLang) {
    setLang(newLang);
    window.location.reload();
  }
};

// sets new value into the local storage
const setLang = (newLang) => {
  localStorage.setItem('lang', newLang);
};

export default LanguageSwitcher;
